import { zodResolver } from '@hookform/resolvers/zod';
import { t } from 'i18next';
import { useForm } from 'react-hook-form';

import { company } from '~/company/Company';
import { Button } from '~/components/isolated/Button';
import Input from '~/components/isolated/Input';
import {
  createOnboardingValidationSchema,
  type OnboardingSchema,
} from '~/utils/validators';

import styles from './Form.module.scss';

type ContentBottomSheetProps = {
  onPrevPress: () => void;
  onLaterPress: () => void;
  onSubmitForm: (data: { name: string; email: string }) => void;
  emailPlaceholder: string;
  firstNamePlaceholder: string;
  isVisibleInputLabels: boolean;
  isVisibleInputs: boolean;
};

export const Form = ({
  emailPlaceholder,
  firstNamePlaceholder,
  onSubmitForm,
  onLaterPress,
}: ContentBottomSheetProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<OnboardingSchema>({
    resolver: zodResolver(createOnboardingValidationSchema(t)),
  });
  const firstNameProps = register('name');
  const emailProps = register('email');

  return (
    <div className={styles.container}>
      <img
        className={styles.notificationIcon}
        src={company.images.newsletter.icon}
        alt=""
      />
      <form className={styles.formContainer}>
        <div className={styles.formTitle}>
          Sign up for our newsletter <br /> and receive a promocode <br />
          for your first order
        </div>
        <Input
          error={!!errors.name}
          label={t('onboarding:sign_up:first_name_label')}
          className={styles.input}
          placeholder={
            firstNamePlaceholder ||
            t('onboarding:sign_up:first_name_placeholder')
          }
          {...firstNameProps}
        />
        <Input
          error={!!errors.email}
          label={t('onboarding:sign_up:email_label')}
          className={styles.input}
          placeholder={
            emailPlaceholder || t('onboarding:sign_up:email_placeholder')
          }
          {...emailProps}
        />
        <div className={styles.buttonsContainer}>
          <Button
            className={styles.button}
            variant="brand"
            onClick={handleSubmit(onSubmitForm)}
          >
            {t('onboarding:sign_up_btn')}
          </Button>
          <Button
            className={styles.button}
            variant="secondary"
            onClick={onLaterPress}
          >
            {t('onboarding:later_btn')}
          </Button>
        </div>
      </form>
    </div>
  );
};
